module.exports = __webpack_public_path__ + "static/media/task8Planet4.d98cee5c.png";